<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="2">
            <v-combobox
              v-model="device"
              :items="devices"
              label="Select Tracker"
              return-object
              item-text="name"
              item-value="id"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="2">
            <VueCtkDateTimePicker
              id="stDate"
              v-model="startTime"
              format="DD/MM/YYYY HH:mm"
            />
          </v-col>
          <v-col cols="12" sm="2">
            <VueCtkDateTimePicker
              id="endDate"
              v-model="endTime"
              format="DD/MM/YYYY HH:mm"
            />
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="recalcCTR()">
              <v-icon left dark>mdi-refresh</v-icon>Create CTR
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="createCSV()">
              <v-icon left dark>mdi-download</v-icon>Download CTR
            </v-btn>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn color="secondary" @click="viewSpeedChart()">
              <v-icon left dark>mdi-chart-line</v-icon>Chart
            </v-btn>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn color="secondary" @click="viewSpeedOnMap()">
              <v-icon left dark>mdi-traffic-light</v-icon>Map
            </v-btn>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn color="secondary" @click="viewPowerChart()">
              <v-icon left dark>mdi-traffic-light</v-icon>P-Car Chart
            </v-btn>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn color="secondary" @click="viewHogChart()">
              <v-icon left dark>mdi-traffic-light</v-icon>HOG Chart
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :headers="headers"
        :fixed-header="true"
        :items="curPositions"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50],
        }"
        :items-per-page="40"
        item-key="id"
        @click:row="onRowClick($event)"
        class="elevation-1"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :mobile-breakpoint="100"
      >
        <!-- <template v-slot:item.act_arr="{ item }">
      {{getFormattedTime(item.act_arr)}}
   </template>
   <template v-slot:item.act_dep="{ item }">
      {{getFormattedTime(item.act_dep)}}
   </template> -->
      </v-data-table>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="4000" :color="snackbarColour">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import jsonexport from "jsonexport/dist";
import { saveAs } from "file-saver";
import { mapState, mapGetter, mapActions } from "vuex";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  name: "GoodsAnalysis",
  components: {
    VueCtkDateTimePicker,
  },
  data() {
    return {
      csvurl: null,
      startTime: null,
      endTime: null,
      snackbar: false,
      snackbarText: "",
      snackbarColour: "info",
      device: {
        name: "",
        id: 0,
      },
      devices: [],
      errors: [],
      headers: [
        {
          text: "Sl No.",
          align: "left",
          sortable: true,
          value: "srl_no",
        },
        {
          text: "Staion",
          align: "left",
          sortable: false,
          value: "stn_code",
        },
        {
          text: "Act Arr",
          sortable: false,
          value: "act_arr",
        },
        {
          text: "Act dep",
          sortable: false,
          value: "act_dep",
        },
        {
          text: "Geofence enter speed",
          value: "geofence_enter_speed",
        },
        {
          text: "Stop Time",
          value: "stop_time",
        },
        {
          text: "Sec. Dist",
          value: "sectional_dist",
          sortable: true,
        },
        // {
        //   text: 'Avg. Speed',
        //   value: 'avg_speed',
        //   sortable: true
        // },
        {
          text: "Max. Speed",
          value: "sec_max_speed",
          sortable: true,
        },
      ],
      position: {},
      positions: [],
      isLoading: false,
    };
  },
  created() {
    this.startTime =
      this.curStartTime ||
      moment()
        .subtract(2, "h")
        .format("DD/MM/YYYY HH:mm:ss");
    this.endTime = this.curEndTime || moment().format("DD/MM/YYYY HH:mm:ss");
    this.getDevices();
    this.device.name = this.curDeviceName;
    this.device.id = this.curDeviceId;
  },
  computed: {
    ...mapState([
      "curDeviceId",
      "curDeviceName",
      "curTrainNo",
      "curTrainDate",
      "curOrg",
      "curArr",
      "curDest",
      "curDep",
      "curPosStartId",
      "curPosDestId",
      "curStartTime",
      "curEndTime",
      "curPositions",
    ]),
  },
  methods: {
    ...mapActions([
      "updateCurDeviceId",
      "updateCurDeviceName",
      "updateCurTrainNo",
      "updateCurTrainDate",
      "updateCurOrg",
      "updateCurArr",
      "updateCurDest",
      "updateCurDep",
      "updateCurPosStartId",
      "updateCurPosDestId",
      "updateCurStartTime",
      "updateCurEndTime",
      "updateCurPositions",
    ]),
    onRowClick($event) {
      //  console.log($event);
    },
    clear() {},
    getCtr(para) {
      this.isLoading = true;
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      //  axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/geofences`,{params: p})
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/tc/adhocctr`, {
          params: para,
        })
        .then((response) => {
          // console.log(response.data);
          this.updateCurPositions(response.data);
          // this.curPositions = response.data
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Signin",
            });
          }
        });
    },
    getPositions() {
      var p = {
        device_id: this.curDeviceId,
        dep: moment(this.curDep).format(),
        arr: moment(this.curArr)
          .add(30, "m")
          .format(),
      };
      this.isLoading = true;
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      //  axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/geofences`,{params: p})
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/tc/positions`, {
          params: p,
        })
        .then((response) => {
          // console.log(response.data);
          this.positions = response.data;
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Signin",
            });
          }
        });
    },
    getDevices() {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      axios
        .get(`${process.env.VUE_APP_API_URL}/device/device_list`)
        .then((response) => {
          // console.log(response);
          this.devices = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    recalcCTR() {
      // var duration = moment(this.startTime, ['DD/MM/YYYY HH:mm']).diff(moment(this.endTime, ['DD/MM/YYYY HH:mm']), 'hours')
      // console.log(duration)
      // if (this.startTime != null && this.endTime != null &&  duration < 6) {
      this.updateCurStartTime(this.startTime);
      this.updateCurEndTime(this.endTime);
      this.updateCurDeviceId(this.device.id);
      this.updateCurDeviceName(this.device.name);
      var p = {
        device_id: this.device.id,
        dep: moment(this.startTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format(),
        arr: moment(this.endTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format(),
      };
      this.getCtr(p);
      // } else {
      //   this.snackbarText = "Please select duration < 6 hours"
      //   this.snackbarColour = 'error'
      //   this.snackbar = true
      // }
    },

    getFormattedTime(t) {
      if (t !== "--") {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
        var testDateUtc = moment(lt);
        //  var localDate = moment(testDateUtc).local();
        return testDateUtc.format("HH:mm:ss");
      }
    },
    getFormattedDate(t) {
      return moment(t).format("DD/MM/YYYY");
    },
    createCSV() {
      let csvContent = "data:text/csv;charset=utf-8,";
      var filename =
        moment(this.startTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format("DD-MM-YYYY") +
        "-" +
        this.curDeviceName +
        ".csv";
      var ctr = [];
      for (var i = 0; i < this.curPositions.length; i++) {
        ctr.push({
          srl_no: this.curPositions[i]["srl_no"],
          stn_code: this.curPositions[i]["stn_code"],
          act_arr: this.curPositions[i]["act_arr"],
          act_dep: this.curPositions[i]["act_dep"],
          stop_time: this.curPositions[i]["stop_time"],
          stn_enter_speed: this.curPositions[i]["geofence_enter_speed"],
          sec_distance: this.curPositions[i]["sectional_dist"],
          sec_max_speed: this.curPositions[i]["sec_max_speed"],
        });
      }
      ctr[0]["stop_time"] = "--";
      ctr[0]["stn_enter_speed"] = "--";
      ctr[this.curPositions.length - 1]["stop_time"] = "--";

      jsonexport(ctr, function(err, csv) {
        if (err) return console.log(err);
        //console.log(csv);
        var blob = new Blob([csv], {
          type: "data:text/csv;charset=utf-8,",
        });
        saveAs(blob, filename);
      });
    },
    viewSpeedChart() {
      // this.$router.push({ name: 'SpeedChart'})
      console.log(
        this.curPositions[this.curPositions.length - 1]["pos_start_id"],
        this.curPositions[this.curPositions.length - 1]["pos_dest_id"]
      );
      this.updateCurTrainDate(
        moment(this.startTime, ["DD/MM/YYYY HH:mm"]).format()
      );

      this.updateCurDeviceId(this.device.id);
      this.updateCurOrg(this.curPositions[0]["stn_code"]);
      this.updateCurDep(
        moment(this.startTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format()
      );
      this.updateCurDest(
        this.curPositions[this.curPositions.length - 1]["stn_code"]
      );
      this.updateCurArr(
        moment(this.endTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format()
      );
      this.updateCurPosStartId(this.curPositions[0]["pos_start_id"]);
      this.updateCurPosDestId(
        this.curPositions[this.curPositions.length - 1]["pos_dest_id"]
      );
      this.$router.push({
        name: "SpeedChartHigh",
      });
      // let routeData = this.$router.resolve({name: 'SpeedChartHigh'});
      // window.open(routeData.href, '_blank');
    },
    viewSpeedOnMap() {
      this.updateCurPosStartId(
        this.curPositions[this.curPositions.length - 1]["pos_start_id"]
      );
      this.updateCurPosDestId(
        this.curPositions[this.curPositions.length - 1]["pos_dest_id"]
      );
      this.updateCurTrainDate(
        moment(this.startTime, ["DD/MM/YYYY HH:mm"]).format()
      );
      this.updateCurTrainNo(this.device.name);
      this.updateCurDeviceId(this.device.id);
      // this.updateCurOrg(this.curPositions[0]["stn_code"]);
      this.updateCurDep(
        moment(this.startTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format()
      );
      // this.updateCurDest(
      //   this.curPositions[this.curPositions.length - 1]["stn_code"]
      // );
      this.updateCurArr(
        moment(this.endTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format()
      );
      this.$router.push({
        name: "SpeedOnMap",
      });
    },
    viewPowerChart() {
      // this.$router.push({ name: 'SpeedChart'})
      // console.log(
      //   this.curPositions[this.curPositions.length - 1]["pos_start_id"],
      //   this.curPositions[this.curPositions.length - 1]["pos_dest_id"]
      // );
      this.updateCurTrainDate(
        moment(this.startTime, ["DD/MM/YYYY HH:mm"]).format()
      );
      this.updateCurTrainNo(this.device.name);
      this.updateCurDeviceId(this.device.id);
      // this.updateCurOrg(this.curPositions[0]["stn_code"]);
      this.updateCurDep(
        moment(this.startTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format()
      );
      // this.updateCurDest(
      //   this.curPositions[this.curPositions.length - 1]["stn_code"]
      // );
      this.updateCurArr(
        moment(this.endTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format()
      );
      // this.updateCurPosStartId(this.curPositions[0]["pos_start_id"]);
      // this.updateCurPosDestId(
      //   this.curPositions[this.curPositions.length - 1]["pos_dest_id"]
      // );
      this.$router.push({
        name: "powerCarChartHigh",
      });
      // let routeData = this.$router.resolve({name: 'SpeedChartHigh'});
      // window.open(routeData.href, '_blank');
    },
    viewHogChart() {
          // this.$router.push({ name: 'SpeedChart'})
      // console.log(
      //   this.curPositions[this.curPositions.length - 1]["pos_start_id"],
      //   this.curPositions[this.curPositions.length - 1]["pos_dest_id"]
      // );
      this.updateCurTrainDate(
        moment(this.startTime, ["DD/MM/YYYY HH:mm"]).format()
      );
      this.updateCurTrainNo(this.device.name);
      this.updateCurDeviceId(this.device.id);
      // this.updateCurOrg(this.curPositions[0]["stn_code"]);
      this.updateCurDep(
        moment(this.startTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format()
      );
      // this.updateCurDest(
      //   this.curPositions[this.curPositions.length - 1]["stn_code"]
      // );
      this.updateCurArr(
        moment(this.endTime, ["DD/MM/YYYY HH:mm"])
          .add(330, "minutes")
          .format()
      );
      // this.updateCurPosStartId(this.curPositions[0]["pos_start_id"]);
      // this.updateCurPosDestId(
      //   this.curPositions[this.curPositions.length - 1]["pos_dest_id"]
      // );
      this.$router.push({
        name: "HogChartHigh",
      });
      // let routeData = this.$router.resolve({name: 'SpeedChartHigh'});
      // window.open(routeData.href, '_blank');
    },
    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },
  },
};
</script>
